<template>
  <div class="container">
    <form class="lottery-form" id="lotteryForm" @submit.prevent="submitForm" novalidate>
      <div>
        <div class="row g-md-3 g-1 px-3 needs-validation mt-lg-0">
          <div class="col-12 d-grid text-center fw-semibold py-0 pb-2 mt-2 mb-2">
                    <span class="claim-text fs-4 pb-2">ENTER YOUR EMAIL </span>
                    <span class="claim-text fs-4">TO REDEEM IT </span>
          </div>
      <div class="col-md-6">
        <input type="text" class="form-control" id="validationCustom01" placeholder="First Name"
          v-model="form.firstName" required>
        <div class="invalid-feedback text-white validation-fz">
          Please provide your First Name
        </div>
        <div class="valid-feedback validation-fz text-white">
          Looks good!
        </div>
      </div>
      <div class="col-md-6">
        <input type="text" class="form-control" id="validationCustom01" placeholder="Last Name" v-model="form.lastName"
          required>
        <div class="invalid-feedback text-white validation-fz">
          Please provide your Last Name
        </div>
        <div class="valid-feedback validation-fz text-white">
          Looks good!
        </div>
      </div>
      <div class="col-md-6">
        <input type="phone" class="form-control" id="validationCustom01" placeholder="Phone Number" v-model="form.phone"
          maxlength="10" minlength="10" pattern="^\d{10}$" required>
        <div class="invalid-feedback text-white validation-fz">
          Please provide a Valid Phone Number
        </div>
        <div class="valid-feedback validation-fz text-white">
          Looks good!
        </div>
      </div>
      <div class="col-md-6">
        <input type="text" class="form-control" id="validationCustom01" :placeholder="prizeCode" disabled
          v-model="form.prizeCode" required>
      </div>
      <div class="col-md-12 mb-2">
        <input type="email" class="form-control" id="validationCustom01" placeholder="Email" v-model="form.email"
          required>
        <div class="invalid-feedback text-white validation-fz mb-3">
          Please provide a Valid Email
        </div>
        <div class="valid-feedback validation-fz text-white">
          Looks good!
        </div>
        </div>
      </div>
      </div>
      
      <div class="col-12 text-center">
        <button class="btn px-4 py-0 btn-spin mt-2 mt-lg-4 rounded-pill"
            type="submit">CLAIM MY BONUS</button>
      </div>
    </form>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import axios from 'axios';
//import Confetti from 'canvas-confetti'

export default {
  props: [
    "prizeCode",
    "prizeName"
  ],
  data() {
    return {
      form: {
        webhookID: "c29e2002-d359-2b3d-35c4-b07f2d3740c8",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        notes: "",
        campaignName: "holidays-2025",
        prize: '',
      },

    }
  },
  methods: {
    async submitForm({ target }) {
      if (target.checkValidity()) {
        this.form.notes = "Prize: " + this.prizeName + " | Prize Code: " + this.prizeCode
        this.form.prize = this.prizeName
        this.loadingMessage();
        var self = this;
        // eslint-disable-next-line
        await axios.create({ transformRequest: [(data, _headers) => JSON.stringify(data)] })
          .post('https://hooks.zapier.com/hooks/catch/11321198/2tjckb8/', this.form)
          // eslint-disable-next-line
          .then(function (_response) {
            self.alertMessage()
            self.resetValues()
          })
          .catch(function (error) {
            // eslint-disable-next-line
            console.log(error);
            self.errorMessage()
          });

      } else target.classList.add('was-validated')
    },
    submitFormt() {

    },
    errorMessage() {
      return Swal.fire({
        icon: "warning",
        title: "Oops",
        text: "An unexpected error ocurred, please try again.",
        //iconColor: "#029195",
        showConfirmButton: false,
        timer: 5000,
        iconColor: "red",
        backdrop: `rgba(74, 192, 192,0.7)`,
      });
    },
    loadingMessage() {
      this.loading = Swal.mixin({
        customClass: {
          loader: 'spinner',
        }
      })
      return this.loading.fire({
        text: "Submitting",
        showConfirmButton: false,
        iconColor: "#39720b",
        color: "#39720b",
        backdrop: `rgba(7, 114, 49,0.7)`,
        width: 160,
        timerProgressBar: true,
        // timer: 3000,
        didOpen: () => {
          this.loading.showLoading();
        },
      });
    },
    alertMessage() {
      this.tab = 3
      localStorage.setItem('prize', 'true');
      return Swal.fire({
        icon: "success",
        title: "Thanks, all ready set.",
        text: "An agent will be in touch with you soon.",
        color: "#029195",
        showConfirmButton: false,
        timer: 5000,
        iconColor: "#029195",
        backdrop: `rgba(7, 114, 49,0.7)`,
      }).then(() => {
        // Cerrar el modal automáticamente después del mensaje
        const modal = document.querySelector('#wheel__modal');
        if (modal) {
          // eslint-disable-next-line
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance) {
            modalInstance.hide();
          }
        }
      });
    },
    initialValues() {
      return {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        prizeCode: null
      };
    },
    resetValues() {
      this.form = this.initialValues();
      document.getElementById("lotteryForm").classList.remove("was-validated");
    },
  },
  mounted() {
    
  }
}
</script>

<style scoped>
    .btn-spin,
    .btn-spin:hover {
        background-color: #f23740 !important;
        font-family: Arial;
        font-weight: 600;
        color: #ffff;
        border: none;
        letter-spacing: 1px;
        font-size: 25px;
        box-shadow: 183, 1, 23, 1px #b70117;
        -webkit-box-shadow: 0px 6px 0px 0px #b70117;
        -moz-box-shadow: 183, 1, 23, 1px #b70117;
        position: relative;
        z-index: 3 !important;
        /* -webkit-text-stroke: .1px; */
        text-shadow: 1px 1px 0 rgba(128, 128, 128, 0.2), -1px -1px 0 rgba(128, 128, 128, 0.2), 1px -1px 0 rgba(128, 128, 128, 0.2), -1px 1px 0 rgba(128, 128, 128, 0.2);
    }
  
    .swal2-loader {
        border-color: #ef527d !important;
    }

.validation-fz {
  font-size: 11px;
}

.terms {
  font-size: 12px;
  color: #fff;
  font-weight: 100;
}
.claim-text{
  color: white;
  font-weight: 500 !important;
  line-height: 18px;
}

.lottery-form {
  min-height: 350px;
}

.form-background {
  background-color: #F2EFEA;
  position: relative;
  margin-left: calc(-1 * var(--bs-gutter-x, 0.75rem));
  margin-right: calc(-1 * var(--bs-gutter-x, 0.75rem));
  padding: 25px var(--bs-gutter-x, 0.75rem) 5px;
}

/* Ajuste específico para móvil */
@media (max-width: 767px) {
  .form-background {
    margin-left: -42px;
    margin-right: -42px;
    padding: 25px 42px 5px;
  }
}

/* Ajuste para tablet y desktop */
@media (min-width: 768px) {
  .form-background {
    margin-left: -40px; /* Aumentado para llenar completamente */
    margin-right: -40px;
    padding: 25px 40px 5px;
  }
}



</style>